import { Breadcrumb } from "@app/shared/components/Breadcrumb";
import { LessonCommunityTab } from "@app/shared/components/Comments";
import { Tabs } from "@design-system/components/Tabs";
import { Tab } from "@design-system/components/Tabs/Tab";
import { trans } from "@mongez/localization";
import { BookOpen, MessageCircleMore, Sparkles, Tag } from "lucide-react";
import {
  LessonContentTab,
  LessonHeader,
  LessonOffersTab,
  LessonQuickActions,
  OffersTabWithCounter,
} from "../../components";
import { LessonDescription } from "../../components/LessonDescription";
import { useLessonDetailsPage } from "../../hooks";

export function LessonDetailsPageContent() {
  const { activeTab, breadcrumbs, commentsEnabled, lesson, setActiveTab } =
    useLessonDetailsPage();

  return (
    <div className="app-page-canvas relative overflow-hidden pb-16">
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[34rem] bg-[radial-gradient(circle_at_top_right,rgba(124,58,237,0.12),transparent_42%),radial-gradient(circle_at_top_left,rgba(14,165,233,0.12),transparent_38%)]" />

      <div className="container mx-auto px-3 py-4 sm:px-4 sm:py-8">
        <div className="mb-5 rounded-2xl border border-white/80 bg-white/75 px-4 py-3 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-950/75">
          <Breadcrumb items={breadcrumbs} />
        </div>

        <div className="grid grid-cols-1 items-start gap-6 xl:grid-cols-[minmax(0,1fr)_22rem]">
          <div className="space-y-6">
            <LessonHeader />
            <LessonDescription />
          </div>
          <LessonQuickActions />
        </div>

        <section className="mt-8 overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/40 dark:border-slate-800 dark:bg-slate-950 dark:shadow-black/20 sm:mt-10">
          <div className="border-b border-slate-100 bg-gradient-to-r from-violet-50 via-white to-sky-50 px-5 py-5 dark:border-slate-800 dark:from-violet-950/25 dark:via-slate-950 dark:to-sky-950/20 sm:px-7">
            <div className="flex items-center gap-3">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-violet-600 to-indigo-600 text-white shadow-lg shadow-violet-200 dark:shadow-none">
                <Sparkles className="h-6 w-6" />
              </span>
              <div>
                <h2 className="text-xl font-black text-slate-950 dark:text-white">
                  {trans("grades.learningWorkspace")}
                </h2>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                  {trans("grades.learningWorkspaceDescription")}
                </p>
              </div>
            </div>
          </div>

          <Tabs
            value={activeTab}
            onValueChange={setActiveTab}
            keepMounted
            id="lesson-workspace"
            className="w-full [&_[role=tablist]]:overflow-x-auto [&_[role=tablist]]:px-3 [&_[role=tablist]]:pt-3 sm:[&_[role=tablist]]:px-6"
          >
            <Tab
              value="content"
              label={trans("content")}
              icon={<BookOpen className="h-4 w-4" />}
            >
              <LessonContentTab />
            </Tab>
            <Tab
              value="offers"
              label={<OffersTabWithCounter />}
              icon={<Tag className="h-4 w-4" />}
            >
              <LessonOffersTab />
            </Tab>
            {commentsEnabled ? (
              <Tab
                value="comments"
                label={trans("ratings.commentsAndRatings")}
                icon={<MessageCircleMore className="h-4 w-4" />}
              >
                <LessonCommunityTab lessonId={lesson.id} />
              </Tab>
            ) : null}
          </Tabs>
        </section>
      </div>
    </div>
  );
}
